import { Select } from '@mantine/core';
import { LanguageMeta, LocalizationService } from '@newo/localization';
import { useMemo } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';

const LanguageSelect = () => {
	const { localization } = useHostContext();

	const data = useMemo(() => {
		return LocalizationService.getSupportedLanguages().map((lang) => ({
			value: lang,
			label: `${LanguageMeta[lang].flag} ${LanguageMeta[lang].label}`
		}));
	}, []);

	return (
		<Select
			comboboxProps={{
				transitionProps: { transition: 'pop', duration: 200 }
			}}
			data={data}
			onChange={localization.onChangeLanguage}
			value={localization.language}
		/>
	);
};

export default LanguageSelect;
